import React, { FormHTMLAttributes } from 'react';
import Box, { TBoxProps } from '../Box/Box';

const Form = (
  props: Omit<TBoxProps, 'as' | 'name'> &
    Pick<
      FormHTMLAttributes<HTMLFormElement>,
      'action' | 'method' | 'noValidate' | 'target' | 'encType' | 'autoComplete'
    >,
) => <Box {...props} as="form" name="Form" />;

export default Form;
